export const bloodPressure30day = {
  data: [
    {
      id: 38,
      systolic: '130',
      diastolic: '90',
      priority: 1,
      dateTime: '2021-09-24T21:04:41.229Z',
      createdAt: '2021-09-24T21:04:54.240Z',
      updatedAt: '2021-09-24T21:04:54.240Z',
      userId: 273,
      patientVitalId: 940,
      userDeviceId: null,
      pulseRateId: null,
      pulseRate: null,
      unit: 'mmHg',
      fromDevice: false,
      device: null,
    },
    {
      id: 36,
      systolic: '134',
      diastolic: '90',
      priority: 2,
      dateTime: '2021-09-13T15:00:57.193Z',
      createdAt: '2021-07-13T15:01:17.960Z',
      updatedAt: '2021-07-13T15:01:17.960Z',
      userId: 218,
      patientVitalId: 716,
      userDeviceId: null,
      pulseRateId: null,
      pulseRate: null,
      unit: 'mmHg',
      fromDevice: false,
      device: null,
    },
    {
      id: 35,
      systolic: '135',
      diastolic: '90',
      priority: 1,
      dateTime: '2021-09-07T13:08:23.038Z',
      createdAt: '2021-07-07T13:08:55.545Z',
      updatedAt: '2021-07-07T13:08:55.545Z',
      userId: 218,
      patientVitalId: 682,
      userDeviceId: null,
      pulseRateId: null,
      pulseRate: null,
      unit: 'mmHg',
      fromDevice: false,
      device: null,
    },
    {
      id: 16,
      systolic: '125',
      diastolic: '90',
      priority: 2,
      dateTime: '2020-09-17T21:28:04.718Z',
      createdAt: '2020-12-17T21:28:28.723Z',
      updatedAt: '2020-12-17T21:28:28.723Z',
      userId: 275,
      patientVitalId: 206,
      userDeviceId: null,
      pulseRateId: null,
      pulseRate: null,
      unit: 'mmHg',
      fromDevice: false,
      device: null,
    },
  ],
  limit: 10,
  skip: 0,
  total: 23,
};

export const bloodPressure7day = {
  data: [
    {
      id: 35,
      systolic: '135',
      diastolic: '90',
      priority: 1,
      dateTime: '2021-07-07T13:08:23.038Z',
      createdAt: '2021-07-07T13:08:55.545Z',
      updatedAt: '2021-07-07T13:08:55.545Z',
      userId: 218,
      patientVitalId: 682,
      userDeviceId: null,
      pulseRateId: null,
      pulseRate: null,
      unit: 'mmHg',
      fromDevice: false,
      device: null,
    },
    {
      id: 16,
      systolic: '125',
      diastolic: '90',
      priority: 2,
      dateTime: '2020-07-17T21:28:04.718Z',
      createdAt: '2020-12-17T21:28:28.723Z',
      updatedAt: '2020-12-17T21:28:28.723Z',
      userId: 275,
      patientVitalId: 206,
      userDeviceId: null,
      pulseRateId: null,
      pulseRate: null,
      unit: 'mmHg',
      fromDevice: false,
      device: null,
    },
  ],
  limit: 10,
  skip: 0,
  total: 0,
};
